import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { IPage } from '../../../services/base/page';
import { DataStoreService } from '../../../services/data-store.service';
import { RoutePageComponent } from '../route-page/route-page.component';
import { NavigationFooterComponent } from '../navigation-footer/navigation-footer.component';
import { ButtonComponent } from "@pacificspecialtyinsurancecompany/psic-ng-components";

@Component({
    selector: 'app-error-system-failure',
    imports: [RoutePageComponent, NavigationFooterComponent, ButtonComponent],
    templateUrl: './error-system-failure.component.html',
    styleUrls: ['./error-system-failure.component.scss']
})
export class ErrorSystemFailureComponent implements OnInit {
    page: IPage | undefined;
    errorStatus: any;
    dataStateName: string = 'ErrorSystemFailure';
    //history go back

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private dataStore: DataStoreService
    ) {}

    ngOnInit(): void {
        // ensure file is named "payment-center.json" under src/assets/local_data/
        this.dataStore.getPageData(this.dataStateName).subscribe((pageData) => {
            this.page = pageData
        });
    }

    pageNavigation($event: any, page: IPage): void {
        if ($event === 'okGotIt' || $event === 'goBack') {
            this.location.back();
        } else {
            this.router.navigate(['/paymentportal']);
        }
    }
}
